import React, { useState, useEffect, useMemo } from 'react';
import {
  Box,
  Modal,
  Button,
  List,
  ListItem,
  ListItemText,
  InputBase,
  IconButton,
  useMediaQuery,
} from '@mui/material';
  import { DataGrid } from '@mui/x-data-grid'; // Asegúrate de instalar y usar @mui/x-data-grid
  import SearchIcon from '@mui/icons-material/Search';
  import { useTheme } from '@mui/material/styles'; // Importa useTheme desde MUI
  import { tokens } from '../../theme'; // Asegúrate de que tokens esté definido en tu tema
  import { getCaballete } from '../../services/caballete.services'; // Asegúrate de tener este servicio
import { getDatosInterfolacionColar, getIdColar, getReprintColar } from '../../services/interfoliacion.services';
import dayjs from "dayjs";
import ModalError from '../modalError';
import ModalCharge from '../modalCharge';
import ModalSuccess from '../modalSucces';
import { getOneOrdenLaminado } from "../../services/stock.services";

  const ModalInterfoliacion = ({ open, onClose, onSelect }) => {
    const [productos, setProductos] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [selectedRows, setSelectedRows] = useState([{}]); // Estado para almacenar las filas seleccionadas
    const [searchValue, setSearchValue] = useState("");
     const [printerInfo, setPrinterInfo] = useState(''); // Estado para guardar la información de la impresora
       const [errorMessage, setErrorMessage] = useState(''); // Estado para guardar posibles errores
       const [registrationError, setRegistrationError] = useState(false);
       const [error, setError] = useState("");
       const [isLoading, setIsLoading] = useState(false);
       const [registrationSuccess, setRegistrationSuccess] = useState(false);
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));

    const columns = [
      { field: "id", headerName: "ID", flex: 1 },
      { field: "serie", headerName: "Serie", flex: 2, cellClassName: "name-column--cell", },
      { field: "cod", headerName: "Codigo", flex: 3,  },
      { field: "medidas", headerName: "Medidas", flex: 2, cellClassName: "name-column--cell", },
    ];

    useEffect(() => {
      const fetchProductos = async () => {
        if (open) { // Solo hacer la solicitud si el modal está abierto
          try {
            const response = await getDatosInterfolacionColar(); // Usa serviceType aquí
            setProductos(response);
            setFilteredData(response);
          } catch (error) {
            console.error("Error al obtener datos del backend:", error);
          }
        }
      };
  
      fetchProductos();
    }, [open]); // Dependencia en la prop 'open'
  

    const handleSearchChange = (event) => {
      setSearchValue(event.target.value);
    };

    const visibleItems = useMemo(() => {
      if (!searchValue) {
        return filteredData;
      }

      const query = searchValue.toLowerCase();
      return productos.filter((producto) => {
        const serieMatch = String(producto.serie || '').toLowerCase().includes(query);
        const descripcionMatch = String(producto.descripcion || '').toLowerCase().includes(query);
        const codMatch = String(producto.cod || '').toLowerCase().includes(query);
        return serieMatch || descripcionMatch || codMatch;
      });
    }, [filteredData, productos, searchValue]);

    // const handleRowClick = (params) => {
    //   const selected = params.row;
    //   setSelectedRows((prevSelectedRows) => [...prevSelectedRows, selected]); // Añade la fila seleccionada al estado
    // };

    const handleCloseModalError = () => {
      setRegistrationError(false);
    };

    const handleCloseModalSucces = () => {
      setRegistrationSuccess(false);
      onClose();
    };
  

  const handleUpdate = async () => {
  setIsLoading(true);
  await new Promise((resolve) => setTimeout(resolve, 1000));

  try {
    const response = await getIdColar(); 

    setRegistrationSuccess(true);

    const { cod, descripcion, peso, colar,  cantidad, serie } = response;
    const fecha = dayjs().format("DD/MM/YYYY HH:mm");

    const ticketData = {
      cod,
      descripcion,
      colar,
      fecha,
      cod_interno: colar,
      peso: peso ?? 0,
      cantidad,
      serie: serie ?? "",
    };

    // Imprimir ticket
    generateZPL(ticketData);

  } catch (error) {
    console.error("Error al enviar los datos", error);

    // Guardar mensaje del backend para mostrar al usuario
    setRegistrationError(true);
    setErrorMessage(error.message || "Error desconocido");
  } finally {
    setTimeout(() => {
      setIsLoading(false);  
      // handleCloseModalSucces();
    }, 2000);
  }
};



//     const generateZPL = async (values) => {


    
//   const formatText = (text, maxLength) => {
//   const words = String(text || '').split(" ");
//   let lines = [];
//   let currentLine = "";

//   words.forEach((word) => {
//     if ((currentLine + word).length > maxLength) {
//       lines.push(currentLine);
//       currentLine = word;
//     } else {
//       currentLine += (currentLine ? " " : "") + word;
//     }
//   });

//   if (currentLine) lines.push(currentLine);
//   return lines;
// };
    
//     // Dividir la descripción y el código en líneas
    
//  const descripcionLines = formatText(values.descripcion, 40); // o 40 según el tamaño de letra
  
//   function generarBloqueDescripcion(startY, x, fontSizeY = 28, fontSizeX = 28, lineSpacing = 40) {
//     return descripcionLines.map((line, index) => {
//       const y = startY - (index * lineSpacing);
//       return `^FO${y},${x}^A0R,${fontSizeY},${fontSizeX}^FD${line}^FS`;
//     }).join('\n');
//   }
//   const bloqueDescripcion1 = generarBloqueDescripcion(300, 50);
//   const bloqueDescripcion2 = generarBloqueDescripcion(300, 800);
//   const bloqueDescripcion3 = generarBloqueDescripcion(300, 1600);
  
  
//   let zpl = `
//       ^XA
//   ^POI
//   ^PW820
//   ^LL2420
  
//   ^FO700,50^A0R,30,30^FDNumero de Serie:${values.serie}^FS
//   ^FO650,50^A0R,25,30^FD${values.fecha}^FS
  
//   ^FO580,50^A0R,30,30^FDCant. Chapa:^FS
//   ^FO520,90^A0R,30,30^FD${values.cantidad}^FS
  
//   ^FO580,300^A0R,30,30^FDPeso:^FS
//   ^FO520,330^A0R,30,30^FD${values.peso}^FS
  
//   ^FO420,50^A0R,25,30^FDFABRICA:${values.serie}^FS
//   ^FO370,50^A0R,30,30^FD${values.cod}^FS
  
//   ${bloqueDescripcion1}
  
  
//   ^FO500,500^BQN,2,8^FDQA,${values.serie}^FS
//   ^FO100,740^GB700,3,3,B,0^FS
  
//   ^FO700,800^A0R,30,30^FDNumero de Serie:${values.serie}^FS
//   ^FO650,830^A0R,25,30^FD${values.fecha}^FS
  
//   ^FO580,800^A0R,30,30^FDCant. Chapa:^FS
//   ^FO520,850^A0R,30,30^FD${values.cantidad}^FS
  
//   ^FO580,1080^A0R,30,30^FDPeso:^FS
//   ^FO520,1110^A0R,30,30^FD${values.peso}^FS
  
//   ^FO420,800^A0R,25,30^FDFABRICA:${values.serie}^FS
//   ^FO370,800^A0R,30,30^FD${values.cod}^FS
  
//   ${bloqueDescripcion2}
  
//   ^FO500,1350^BQN,2,8^FDQA,${values.serie}^FS
//   ^FO100,1550^GB700,3,3,B,0^FS
  
//   ^FO700,1600^A0R,30,30^FDNumero de Serie:${values.serie}^FS
//   ^FO650,1630^A0R,25,30^FD${values.fecha}^FS
  
//   ^FO580,1600^A0R,30,30^FDCant. Chapa:^FS
//   ^FO520,1650^A0R,30,30^FD${values.cantidad}^FS
  
//   ^FO580,1880^A0R,30,30^FDPeso:^FS
//   ^FO520,1910^A0R,30,30^FD${values.peso}^FS
  
//   ^FO420,1600^A0R,25,30^FDFABRICA:${values.serie}^FS
//   ^FO370,1600^A0R,30,30^FD${values.cod}^FS
//   ${bloqueDescripcion3}
//   ^FO500,2150^BQN,2,8^FDQA,${values.serie}^FS
  
//   ^XZ
//   `;
    
    
  
//     if (window.BrowserPrint) { // Asegúrate de que BrowserPrint está disponible
//       window.BrowserPrint.getDefaultDevice("printer", 
//       (device) => {
//           if (device) {
//           setPrinterInfo(`Dispositivo predeterminado encontrado: ${device.name}`);
//           let zplCommand = zpl;
  
//           // 3. Usar la función send para enviar los datos al dispositivo
//           device.send(zplCommand, function(response) {
//           }, function(error) {
//               console.error("Error al enviar datos:", error);
//           });
//           } else {
//           setPrinterInfo("No hay una impresora predeterminada configurada.");
//           }
//       },
//       (error) => {
//           setErrorMessage(`Error al obtener el dispositivo predeterminado: ${error}`);
//       }
//       );
//     } else {
//       setErrorMessage('BrowserPrint no está disponible.');
//     }
  
//   };


   const generateZPL = async (values) => {

    const orden = await getOneOrdenLaminado(values.serie);

    
  const formatText = (text, maxLength) => {
  const words = String(text || '').split(" ");
  let lines = [];
  let currentLine = "";

  words.forEach((word) => {
    if ((currentLine + word).length > maxLength) {
      lines.push(currentLine);
      currentLine = word;
    } else {
      currentLine += (currentLine ? " " : "") + word;
    }
  });

  if (currentLine) lines.push(currentLine);
  return lines;
};
    
    // Dividir la descripción y el código en líneas
    const descripcionLines = formatText(orden?.codigo, 40); // o 40 según el tamaño de letra
 const codLines = formatText(orden?.dcod || values.cod, 40);
 const peso = Number(values.cantidad * orden.peso).toFixed(2);

  function generarBloqueDescripcion(startY, x, fontSizeY = 28, fontSizeX = 28, lineSpacing = 40) {
    return descripcionLines.map((line, index) => {
      const y = startY - (index * lineSpacing);
      return `^FO${y},${x}^A0R,${fontSizeY},${fontSizeX}^FD${line}^FS`;
    }).join('\n');
  }
  function generarBloqueCod(startY, x, fontSizeY = 30, fontSizeX = 30, lineSpacing = 40) {
    return codLines.map((line, index) => {
      const y = startY - (index * lineSpacing);
      return `^FO${y},${x}^A0R,${fontSizeY},${fontSizeX}^FD${line}^FS`;
    }).join('\n');
  }
  const bloqueDescripcion1 = generarBloqueDescripcion(300, 50);
  const bloqueDescripcion2 = generarBloqueDescripcion(300, 800);
  const bloqueDescripcion3 = generarBloqueDescripcion(300, 1600);
  const cod1 = generarBloqueCod(450, 50, 30, 30);
  const cod2 = generarBloqueCod(450, 800, 30, 30);
  const cod3 = generarBloqueCod(450, 1600, 30, 30);
  
  
  let zpl = `
      ^XA
  ^POI
  ^PW820
  ^LL2420
  
  ^FO700,50^A0R,30,30^FDNumero de Serie:${values.serie}^FS
  ^FO650,50^A0R,25,30^FD${values.fecha}^FS
  
  ^FO580,50^A0R,30,30^FDCant. Chapa:^FS
  ^FO520,90^A0R,30,30^FD${values.cantidad}^FS
  
  ^FO580,300^A0R,30,30^FDPeso:^FS
  ^FO520,330^A0R,30,30^FD${peso}^FS
  
  
  ${bloqueDescripcion1}
  
  
  ^FO500,500^BQN,2,8^FDQA,${values.serie}^FS
  ^FO100,740^GB700,3,3,B,0^FS
  
  ^FO700,800^A0R,30,30^FDNumero de Serie:${values.serie}^FS
  ^FO650,830^A0R,25,30^FD${values.fecha}^FS
  
  ^FO580,800^A0R,30,30^FDCant. Chapa:^FS
  ^FO520,850^A0R,30,30^FD${values.cantidad}^FS
  
  ^FO580,1080^A0R,30,30^FDPeso:^FS
  ^FO520,1110^A0R,30,30^FD${peso}^FS
  
  ${bloqueDescripcion2}
  
  ^FO500,1350^BQN,2,8^FDQA,${values.serie}^FS
  ^FO100,1550^GB700,3,3,B,0^FS
  
  ^FO700,1600^A0R,30,30^FDNumero de Serie:${values.serie}^FS
  ^FO650,1630^A0R,25,30^FD${values.fecha}^FS
  
  ^FO580,1600^A0R,30,30^FDCant. Chapa:^FS
  ^FO520,1650^A0R,30,30^FD${values.cantidad}^FS
  
  ^FO580,1880^A0R,30,30^FDPeso:^FS
  ^FO520,1910^A0R,30,30^FD${peso}^FS
  
  ${bloqueDescripcion3}
  ^FO500,2150^BQN,2,8^FDQA,${values.serie}^FS
  `;

  if (values.cod && values.cod.startsWith("AA")) {
    zpl += `
  ^FO650,280^A0R,30,30^FD${orden.proceso}^FS
  ^FO650,1050^A0R,30,30^FD${orden.proceso}^FS
  ^FO650,1850^A0R,30,30^FD${orden.proceso}^FS

  ^FO300,50^A0R,40,40^FDAGC:${orden.codFabrica}^FS
  ^FO300,800^A0R,40,40^FDAGC:${orden.codFabrica}^FS
  ^FO300,1600^A0R,40,40^FDAGC:${orden.codFabrica}^FS
  ${cod1}
  ${cod2}
  ${cod3}

      ^FO30,280^A0R,150,150^FDAGC^FS
      ^FO30,288^A0R,150,150^FDAGC^FS
      ^FO30,1010^A0R,150,150^FDAGC^FS
      ^FO30,1020^A0R,150,150^FDAGC^FS
      ^FO30,1860^A0R,150,150^FDAGC^FS
      ^FO30,1869^A0R,150,150^FDAGC^FS
    `;
  }

  zpl += `
  ^XZ
  `;
    
    
  
    if (window.BrowserPrint) { // Asegúrate de que BrowserPrint está disponible
      window.BrowserPrint.getDefaultDevice("printer", 
      (device) => {
          if (device) {
          setPrinterInfo(`Dispositivo predeterminado encontrado: ${device.name}`);
          let zplCommand = zpl;
  
          // 3. Usar la función send para enviar los datos al dispositivo
          device.send(zplCommand, function(response) {
          }, function(error) {
              console.error("Error al enviar datos:", error);
          });
          } else {
          setPrinterInfo("No hay una impresora predeterminada configurada.");
          }
      },
      (error) => {
          setErrorMessage(`Error al obtener el dispositivo predeterminado: ${error}`);
      }
      );
    } else {
      setErrorMessage('BrowserPrint no está disponible.');
    }
  
  };
  const handleReprint = async () => {

    // setIsLoading(true);
    // await new Promise((resolve) => setTimeout(resolve, 1000));
    try {
      const response = await getReprintColar(); // Usa serviceType aquí
      const {cod, descripcion, total_peso, cod_interno, peso, colar, serie, cantidad } = response;
      const fecha = dayjs().format("DD/MM/YYYY HH:mm");
      const ticketData = {
        cod: cod,
        descripcion: descripcion,
       //  cantidad_entrada: cantidad_entrada,
        colar: colar,
        fecha: fecha,
        cod_interno: colar || serie || cod_interno || '',
        peso: (typeof peso !== 'undefined' ? peso : total_peso) ?? 0,
        cantidad: cantidad,
        serie: serie ?? cod_interno,
      };
      // Call function to print ticket
      generateZPL(ticketData);
    } catch (error) {
      console.error("Error al obtener datos del backend:", error);
    }

  }
    return (
      <Modal
        open={open}
        onClose={onClose}
        aria-labelledby="modal-horario-title"
        aria-describedby="modal-horario-description"
        sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
        BackdropProps={{
          style: { backgroundColor: 'rgba(0, 0, 0, 0.5)' },
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            width: { xs: '90vw', md: '75vw', lg: '60vw' },
            maxHeight: { xs: '88vh', md: '80vh' },
            backgroundColor: colors.primary[600],
            borderRadius: '18px',
            boxShadow: '0 18px 48px rgba(0,0,0,0.4)',
            overflow: 'hidden',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: { xs: 'column', sm: 'row' },
              alignItems: { xs: 'flex-start', sm: 'center' },
              justifyContent: 'space-between',
              gap: 2,
              padding: { xs: '16px 20px', md: '24px 28px' },
              backgroundColor: colors.primary[500],
            }}
          >
            <Box>
              <h1 id="owner-modal-title" style={{ margin: 0 }}>Interfoliados</h1>
              <p style={{ margin: 0, opacity: 0.75 }}>Consulta y gestiona los colares disponibles</p>
              <p style={{ margin: '4px 0 0', fontSize: '0.9rem', opacity: 0.7 }}>
                Cantidad: {visibleItems.length}
              </p>
            </Box>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                backgroundColor: colors.primary[400],
                borderRadius: '12px',
                paddingX: 1.5,
                paddingY: 0.5,
                width: { xs: '100%', sm: '280px' },
              }}
            >
              <InputBase
                sx={{ flex: 1 }}
                placeholder="Buscar por serie, código o descripción"
                value={searchValue}
                onChange={handleSearchChange}
              />
              <IconButton type="button" sx={{ p: 1 }}>
                <SearchIcon />
              </IconButton>
            </Box>
          </Box>
          <Box
            sx={{
              flex: 1,
              overflowY: 'auto',
              padding: { xs: '0 20px 20px', md: '0 28px 28px' },
              '&::-webkit-scrollbar': { width: '6px' },
              '&::-webkit-scrollbar-thumb': {
                backgroundColor: colors.primary[500],
                borderRadius: '999px',
              },
            }}
          >
            {isMobile ? (
              <List dense disablePadding>
                {visibleItems.map((item) => (
                  <ListItem
                    key={item.id}
                    disablePadding
                    sx={{
                      backgroundColor: colors.primary[500],
                      borderRadius: '12px',
                      marginBottom: '10px',
                    }}
                  >
                    <ListItemText
                      primary={`Serie: ${item.serie || '-'}`}
                      secondary={
                        <span>
                          {item.cod ? `Código: ${item.cod}` : 'Sin código'}
                          <br />
                          {/* {item.descripcion || 'Sin descripción'} */}
                        </span>
                      }
                    />
                  </ListItem>
                ))}
              </List>
            ) : (
              <Box
                sx={{
                  height: '60vh',
                  width: '100%',
                  '& .MuiDataGrid-root': { border: 'none' },
                  '& .MuiDataGrid-cell': { borderBottom: 'none' },
                  '& .name-column--cell': { color: colors.greenAccent[300] },
                  '& .MuiDataGrid-columnHeaders': {
                    backgroundColor: colors.blueAccent[900],
                    borderBottom: 'none',
                  },
                  '& .MuiDataGrid-virtualScroller': {
                    backgroundColor: colors.primary[400],
                  },
                  '& .MuiDataGrid-footerContainer': {
                    borderTop: 'none',
                    backgroundColor: colors.blueAccent[900],
                  },
                  '& .MuiCheckbox-root': {
                    color: `${colors.greenAccent[200]} !important`,
                  },
                }}
              >
                <DataGrid rows={visibleItems} columns={columns} />
              </Box>
            )}
          </Box>
          <Box
            sx={{
              display: 'flex',
              flexDirection: { xs: 'column', sm: 'row' },
              gap: 2,
              justifyContent: 'flex-end',
              alignItems: { xs: 'stretch', sm: 'center' },
              padding: { xs: '16px 20px 20px', md: '20px 28px 28px' },
              backgroundColor: colors.primary[500],
            }}
          >
            <Button
              type="button"
              color="secondary"
              variant="contained"
              onClick={handleReprint}
              sx={{
                backgroundColor: 'rgb(206, 220, 0)',
                border: 'none',
                color: 'black',
                height: '48px',
                width: { xs: '100%', sm: 'auto' },
                minWidth: { sm: '150px' },
                borderRadius: '999px',
                '&:hover': { backgroundColor: '#bac609' },
              }}
            >
              Reimprimir
            </Button>
            <Button
              type="button"
              color="secondary"
              variant="contained"
              onClick={handleUpdate}
              sx={{
                backgroundColor: 'rgb(206, 220, 0)',
                border: 'none',
                color: 'black',
                height: '48px',
                width: { xs: '100%', sm: 'auto' },
                minWidth: { sm: '150px' },
                borderRadius: '999px',
                '&:hover': { backgroundColor: '#bac609' },
              }}
            >
              Crear Colar
            </Button>
          </Box>
          <ModalError open={registrationError} onClose={handleCloseModalError} error={errorMessage} />
          <ModalCharge isLoading={isLoading} />
          <ModalSuccess open={registrationSuccess} onClose={handleCloseModalSucces} />
        </Box>
      </Modal>
    );
  };
  
  export default ModalInterfoliacion;